import React, { FC } from 'react';
import { iconSize } from '../../../../../../constants/icon.constants';
import Icon from '../../../../../@shared/icon';
import useAnimationEnd from '../../../../../../hooks/useUnMountOnAnimationEnd';
import { TSelectedFilterOptions } from '../../../../types/dealerLocatorLanding.types';
import './styles.scss';

export type TAccordionProps = {
  accordionTitle?: JSX.Element;
  accordionOptions?: Partial<{
    Code?: string;
    Title?: JSX.Element | string;
  }>[];
  canShowAccordionContent: boolean;
  handleSwitchClick: () => void;
  handleCheckBoxClick: () => void;
  localSelectedFilter: TSelectedFilterOptions;
  setLocalSelectedFilter: React.Dispatch<React.SetStateAction<TSelectedFilterOptions>>;
};

const Accordion: FC<TAccordionProps> = ({
  accordionTitle: title = '',
  accordionOptions = [],
  localSelectedFilter = {},
  setLocalSelectedFilter,
  canShowAccordionContent = false,
  handleSwitchClick,
  handleCheckBoxClick,
}) => {
  const canShowDOM = useAnimationEnd(canShowAccordionContent, 290);

  const saveLocalSelectedFilter = (Code: string, filterIndex: number, isChecked) => {
    const localSelectedFilterCopy = localSelectedFilter;
    const selectedFilterIndexArray = localSelectedFilterCopy[Code];
    if (selectedFilterIndexArray) {
      if (isChecked) {
        localSelectedFilterCopy[Code] = localSelectedFilterCopy[Code].filter(
          (eachSelectedFilterInd) => eachSelectedFilterInd !== filterIndex
        );
      } else {
        localSelectedFilterCopy[Code] = [...selectedFilterIndexArray, filterIndex];
      }
    } else {
      localSelectedFilterCopy[Code] = [filterIndex];
    }
    if (localSelectedFilter[Code]?.length === 0) delete localSelectedFilterCopy[Code];
    setLocalSelectedFilter({ ...localSelectedFilterCopy });
  };

  if (!accordionOptions.length) return <></>;

  return (
    <div className="dealer-accordion-filter">
      <div
        className={`dealer-accordion-filter__switch${canShowAccordionContent ? ' dealer-accordion-filter__switch--open' : ''}`}
        onClick={handleSwitchClick}
      >
        {title}
        <Icon color={'primary'} iconName={`arrow-chevron-${canShowAccordionContent ? 'up' : 'down'}`} size={iconSize['dsk']} />
      </div>
      {canShowDOM && (
        <div className={`dealer-accordion-filter__panel dealer-accordion-filter__panel${canShowAccordionContent ? '--open' : '--closed'}`}>
          {accordionOptions?.map(({ Code = '', Title }, index) => {
            const isChecked = localSelectedFilter[Code]?.includes?.(index);
            return (
              <label
                htmlFor={Code}
                className="dealer-accordion-filter__panel-item"
                onClick={() => {
                  Code && saveLocalSelectedFilter(Code, index, isChecked);
                  handleCheckBoxClick();
                }}
              >
                <Icon iconName={isChecked ? 'action-checkbox-checked' : 'action-checkbox-default'} size={iconSize['dsk']} />
                <span>{Title}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Accordion;
